export enum ServiceProvider {
  GakkMedia = 1,
  Cloud7Ltd = 2,
  ShadhinMusicLtd = 3,
  Maverick = 4,
}
export enum RobiServiceProvider {
  Cloud7Ltd = 1,
  ShadhinMusicLtd = 2,
  Robi_Maverick = 3,
}
